import { combineReducers } from "redux";
import auth from "./auth";
import cart from "./cart";
import quiz from "./quiz";
import user from "./user/";
import transaction from "./transaction/";
import game from "./game/";

export default combineReducers({
  auth,
  cart,
  quiz,
  user,
  transaction,
  game,
});
